import { Button, ButtonProps } from "@mui/material";
import React, { forwardRef } from "react";

type Props = {
	// ...
} & ButtonProps;

const IMButton = forwardRef<HTMLButtonElement, Props>(({ children, ...rest }, ref) => {
	return (
		<Button variant="contained" color="success" ref={ref} {...rest}>
			{children}
		</Button>
	);
});

export default IMButton;
